export const fallbackLanguage = import.meta.env.VITE_FALLBACK_LANGUAGE || 'da';
